export const parseTrimline = (trimline: string): string => {
  return trimline.trim().toLowerCase().replace(/\s+/g, '_');
};
